import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout for /app/item/new/*. TanStack nests app.item.new.$type under this
// route, so this MUST render an <Outlet/> — otherwise the composer child never
// mounts (it previously rendered a <Navigate>, which swallowed the composer and
// looked like the vault had locked). The bare /app/item/new path is handled by
// the index route, which redirects to a memo.
export const Route = createFileRoute('/_authed/app/item/new')({
  component: () => <Outlet />,
});
